import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AddContacto } from './contactos.add.component';
import { ChannelsService } from '../../../infrastructure/services/channels.service';
import { ContactosService } from '../../../infrastructure/services/contactos.service';
import { Contacto } from 'app/infrastructure/model/classes/contacto.class';
import { ChannelDetalle } from 'app/infrastructure/model/classes/configuracionChannel.class';

@Component({
  selector: 'contacto-channel',
  templateUrl: './contactos.component.html',
  providers: [ChannelsService, ContactosService]
})
export class ContactosComponent implements OnInit {
  channel: ChannelDetalle;
  contactos: Contacto[];
  codSubscription: string;
  codChannel: string;
  buscarContacto: String;
  cargandoDetalle: Boolean = true;
  cargandoContactos: Boolean = true;
  constructor(private channelsService: ChannelsService, private contactosService: ContactosService, private aRoute: ActivatedRoute, private modalService: NgbModal) { }

  open(contacto: any) {
    const modalRef = this.modalService.open(AddContacto).componentInstance;

    if (contacto) {
      modalRef.contacto = contacto;
    }
  }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
      // const thisComponent = this;
      // this.negociosService.getNegocioDetalle(this.codSistema, this.codNegocio)
      //   .then(function (data) {
      //     thisComponent.negocio = data;
      //     thisComponent.cargandoDetalle = false;
      //   });
      // this.contactosService.getContactos(this.codSistema, this.codNegocio)
      //   .then(function (data) {
      //     thisComponent.contactos = data;
      //     thisComponent.cargandoContactos = false;
      //   });
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel/contactos.component.ts